import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function RidersSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Group%20of%20Cameroonian%20motorcycle%20taxi%20riders%20lined%20up%20on%20street%20Douala%20wearing%20colorful%20helmets%20warm%20sunset%20golden%20hour%20lighting%20urban%20background%20authentic%20local%20atmosphere%20cinematic%20composition%20professional%20editorial%20photography&width=1600&height=900&seq=riders-section-bg-v2&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/75 to-foreground-950/90"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/30 to-transparent"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 lg:px-10 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left - Content */}
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-900/60 backdrop-blur-sm border border-primary-500/20 text-primary-300 text-xs font-semibold uppercase tracking-wider mb-5">
              {t("riders.title")}
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 mb-5 leading-tight">
              {t("riders.title")}
            </h2>
            <p className="text-base md:text-lg text-background-300 mb-8 leading-relaxed">
              {t("riders.subtitle")}
            </p>

            {/* Benefits */}
            <div className="space-y-5 mb-8">
              {[
                { icon: "ri-time-line", title: t("riders.benefit1_title"), desc: t("riders.benefit1_desc") },
                { icon: "ri-route-line", title: t("riders.benefit2_title"), desc: t("riders.benefit2_desc") },
                { icon: "ri-coins-line", title: t("riders.benefit3_title"), desc: t("riders.benefit3_desc") },
                { icon: "ri-user-add-line", title: t("riders.benefit4_title"), desc: t("riders.benefit4_desc") },
              ].map((benefit, index) => (
                <div key={index} className="flex items-start gap-4 group">
                  <div className="w-11 h-11 rounded-xl bg-primary-900/50 backdrop-blur-sm border border-primary-500/20 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-800/50 transition-colors">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className={`${benefit.icon} text-primary-400`}></i>
                    </div>
                  </div>
                  <div>
                    <h4 className="font-heading text-sm font-semibold text-background-100 mb-1">
                      {benefit.title}
                    </h4>
                    <p className="text-sm text-background-400 leading-relaxed">
                      {benefit.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <Link
              to="/riders"
              className="inline-flex items-center gap-2 px-7 py-3.5 bg-accent-500 text-background-50 rounded-full text-sm font-semibold hover:bg-accent-600 transition-all hover:scale-105 shadow-lg shadow-accent-500/20 whitespace-nowrap cursor-pointer"
            >
              {t("riders.cta")}
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          </div>

          {/* Right - Image Card */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden border-2 border-background-50/10">
              <img
                src="https://readdy.ai/api/search-image?query=Cameroonian%20motorcycle%20delivery%20rider%20in%20helmet%20smiling%20holding%20food%20delivery%20bag%20on%20busy%20Douala%20street%20warm%20golden%20hour%20lighting%20authentic%20urban%20scene%20cinematic%20portrait%20editorial%20photography&width=700&height=800&seq=riders-section-card-v2&orientation=portrait"
                alt="Delivery rider"
                className="w-full h-80 md:h-[450px] object-cover"
              />
              {/* Floating stat */}
              <div className="absolute bottom-4 left-4 right-4 bg-foreground-950/80 backdrop-blur-md rounded-xl p-4 border border-background-50/10">
                <div className="flex items-center justify-between">
                  <div className="text-center">
                    <p className="font-heading text-xl font-bold text-background-50">200+</p>
                    <p className="text-xs text-background-400">Livreurs actifs</p>
                  </div>
                  <div className="w-px h-8 bg-background-50/20"></div>
                  <div className="text-center">
                    <p className="font-heading text-xl font-bold text-background-50">24h</p>
                    <p className="text-xs text-background-400">Pour demarrer</p>
                  </div>
                  <div className="w-px h-8 bg-background-50/20"></div>
                  <div className="text-center">
                    <p className="font-heading text-xl font-bold text-background-50">100%</p>
                    <p className="text-xs text-background-400">Flexible</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}